import React from "react";
import { Card, CardBody, Col, Collapse } from "reactstrap";
import Select from "react-select";
import InputMask from "react-input-mask";
import {
  FiEdit3,
  FiChevronDown,
  FiChevronUp,
  FiPlus,
  FiTrash2,
  FiTable,
} from "react-icons/fi";
import { min } from "lodash";
import { useTranslation } from "react-i18next";
const HmfEdit = ({
  title,
  data,
  form,
  onAddForm,
  onDeleteForm,
  handleInputChange,
  renderBaseOptions,
  renderOuiNonOptions,
  renderInterestRateFrequency,
  renderInterestRateReference,
  renderInterestRateType,
  renderCovenant,
  renderCreditOptions,
  renderFlowType,
  renderParametrageOptions,
  renderTypeFacturationOptions,
  showHide,
  hmfName,
  isAccordionOpen = true,
  setIsAccordionOpen = () => {},
}) => {
  const { t } = useTranslation("");
  // États existants
  const [hideStates, setHideStates] = React.useState(
    form?.reduce((acc, row) => {
      acc[row.index] = false;
      return acc;
    }, {})
  );

  // Fonction pour basculer l'état du collapse
  const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

  const handleRateTypeChange = (index, name, value) => {
    handleInputChange(index, name, value);
    setHideStates((prevState) => ({
      ...prevState,
      [index]: value == 1,
    }));
  };

  if (!data) return null;

  return (
    <Col sm="12">
      <Card
        className="shadow-sm border-0 overflow-hidden"
        style={{ borderRadius: "12px" }}
      >
        {/* En-tête cliquable */}
        <div
          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
          style={{
            background: "#555B21",
            letterSpacing: "0.5px",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={toggleAccordion}
        >
          <div className="d-flex align-items-center">
            {/* <FiTable size={16} className="me-2" /> */}
            <span style={{ fontSize: "0.82rem" }}>{title}</span>
          </div>
          {isAccordionOpen ? (
            <FiChevronUp size={16} />
          ) : (
            <FiChevronDown size={16} />
          )}
        </div>

        {/* Contenu repliable */}
        <Collapse isOpen={isAccordionOpen}>
          <CardBody className="p-0">
            <div className="table-responsive" style={{ margin: 0 }}>
              <table
                className="table table-bordered rounded-0 overflow-hidden fx-table-sm mb-0"
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  fontSize: "0.8rem",
                }}
              >
                {/* Table headers */}
                <thead>
                  <tr>
                    {data?.header.map((columnName, index) => {
                      // Logique de conditionnement des colonnes
                      if (
                        (columnName === "Tranche number" &&
                          hmfName == "theortical_in" &&
                          !showHide.includes(
                            "theortical_cash_flows_in_tranche_number"
                          )) ||
                        (columnName === "Tranche number" &&
                          hmfName == "theortical_out" &&
                          !showHide.includes(
                            "theortical_cash_flows_out_tranche_number"
                          ))
                      ) {
                        return null;
                      }

                      return (
                        <th
                          key={index}
                          style={{
                            background: "#555B21",
                            color: "white",
                            verticalAlign: "top",
                            padding: "8px",
                            fontSize: "0.75rem",
                            fontWeight: "600",
                            letterSpacing: "0.3px",
                            border: "none",
                            minWidth: "7em",
                            maxWidth: "7em",
                          }}
                        >
                          {columnName}
                        </th>
                      );
                    })}
                    <th
                      style={{
                        background: "#555B21",
                        color: "white",
                        padding: "8px",
                        width: "1%",
                        border: "none",
                      }}
                    >
                      <FiTrash2 size={14} />
                    </th>
                  </tr>
                </thead>

                {/* Table body */}
                <tbody>
                  {form
                    ?.filter((item) => item?._destroy !== 1)
                    ?.map((rowData) => (
                      <tr
                        key={rowData.index}
                        style={{ transition: "all 0.15s ease" }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f9fa";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                        }}
                      >
                        {/* Table cells */}
                        {Object.entries(rowData).map(([key, value]) => {
                          if (key !== "id" && key !== "index") {
                            return (
                              <td
                                key={key}
                                style={{
                                  padding: "8px",
                                  border: "1px solid #e9ecef",
                                  backgroundColor: "inherit",
                                  width: "172px",
                                }}
                              >
                                {renderInputField(
                                  key,
                                  value,
                                  rowData,
                                  handleInputChange,
                                  handleRateTypeChange,
                                  hideStates,
                                  title,
                                  renderBaseOptions,
                                  renderOuiNonOptions,
                                  renderInterestRateFrequency,
                                  renderInterestRateReference,
                                  renderInterestRateType,
                                  renderCovenant,
                                  renderCreditOptions,
                                  renderFlowType,
                                  renderParametrageOptions,
                                  renderTypeFacturationOptions
                                )}
                              </td>
                            );
                          }
                          return null;
                        })}

                        {/* Delete button */}
                        <td
                          style={{
                            padding: "8px",
                            border: "1px solid #e9ecef",
                            backgroundColor: "inherit",
                            textAlign: "center",
                          }}
                        >
                          <button
                            className="btn btn-sm btn-outline-danger p-1"
                            onClick={() => onDeleteForm(rowData.index)}
                            style={{
                              border: "none",
                              backgroundColor: "transparent",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#dc3545";
                              e.target.style.color = "white";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "transparent";
                              e.target.style.color = "#dc3545";
                            }}
                          >
                            <FiTrash2 size={14} />
                          </button>
                        </td>
                      </tr>
                    ))}

                  {/* Add button row */}
                  {/* <tr>
                    <td
                      colSpan={data.header.length + 1}
                      style={{
                        padding: "12px 8px",
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #e9ecef",
                        textAlign: "center",
                      }}
                    >
                      
                    </td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Collapse>
      </Card>
      {isAccordionOpen && (
        <button
          className="btn btn-sm btn-success d-inline-flex align-items-center"
          onClick={onAddForm}
          style={{
            fontSize: "0.6rem",
            fontWeight: "600",
            letterSpacing: "0.3px",
            borderRadius: "8px",
            padding: "6px 12px",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "scale(1.02)";
            e.target.style.boxShadow = "0 2px 8px rgba(40, 167, 69, 0.3)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "scale(1)";
            e.target.style.boxShadow = "none";
          }}
        >
          <FiPlus size={14} className="me-1" />
          {t("Ajouter une nouvelle ligne")}
        </button>
      )}
    </Col>
  );
};

// Fonction séparée pour rendre les champs d'entrée (logique extraite)
const renderInputField = (
  key,
  value,
  rowData,
  handleInputChange,
  handleRateTypeChange,
  hideStates,
  title,
  renderBaseOptions,
  renderOuiNonOptions,
  renderInterestRateFrequency,
  renderInterestRateReference,
  renderInterestRateType,
  renderCovenant,
  renderCreditOptions,
  renderFlowType,
  renderParametrageOptions,
  renderTypeFacturationOptions
) => {
  const commonSelectStyle = {
    fontSize: "0.8rem",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
    transition: "all 0.2s ease",
    minHeight: "32px",
    padding: "2px 8px",
    backgroundColor: "white",
  };

  const commonInputStyle = {
    fontSize: "0.8rem",
    borderRadius: "6px",
    border: "1px solid #e9ecef",
    transition: "all 0.2s ease",
    minHeight: "32px",
    padding: "2px 8px",
    backgroundColor: "white",
  };

  // Logique des selects
  if (key === "fx_base_de_calcul_id") {
    return (
      <select
        value={value}
        name="fx_base_de_calcul_id"
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderBaseOptions}
      </select>
    );
  }

  if (key === "parametrage_id") {
    return (
      <select
        value={value}
        name="parametrage_id"
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderParametrageOptions}
      </select>
    );
  }

  if (key === "type_facturation_id") {
    return (
      <select
        value={value}
        name="type_facturation_id"
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderTypeFacturationOptions}
      </select>
    );
  }

  if (key === "interest_rate_reference_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
        disabled={hideStates[rowData.index]}
      >
        {renderInterestRateReference}
      </select>
    );
  }

  if (key === "flow_type_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
        disabled
      >
        {renderFlowType}
      </select>
    );
  }

  if (key === "loan_type_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderCreditOptions}
      </select>
    );
  }

  if (key === "rate_type_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleRateTypeChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderInterestRateType}
      </select>
    );
  }

  if (key === "interest_rate_frequency_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderInterestRateFrequency}
      </select>
    );
  }

  if (key === "covenants_model_id") {
    return (
      <select
        value={value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      >
        {renderCovenant}
      </select>
    );
  }

  // Selects Oui/Non
  const ouiNonKeys = [
    "reel",
    "addition",
    "accrued_interest",
    "active",
    "actif",
  ];
  if (ouiNonKeys.includes(key)) {
    const isDisabled =
      (key === "reel" || key === "addition") &&
      [
        "Produits facturés (échu)",
        "Consommation réelle (à échoir)",
        "Estimation précédente (à échoir)",
        "Estimation suivante (à échoir)",
      ].includes(title);

    return (
      <select
        value={key === "active" ? value?.value || value : value}
        name={key}
        className="form-control form-control-sm"
        style={commonSelectStyle}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
        disabled={isDisabled}
      >
        {renderOuiNonOptions}
      </select>
    );
  }

  // Input dates avec masque
  const dateKeys = [
    "availability_date",
    "date_maturity",
    "instalment_date",
    "drawdown_end_date",
    "Instalment date",
  ];
  if (dateKeys.includes(key)) {
    return (
      <InputMask
        name={key}
        mask="99/99/9999"
        value={value}
        className="form-control form-control-sm"
        style={{ ...commonInputStyle, width: "100px" }}
        onChange={(e) =>
          handleInputChange(rowData.index, e.target.name, e.target.value)
        }
      />
    );
  }

  // Input classique
  return (
    <input
      className="form-control form-control-sm"
      style={commonInputStyle}
      defaultValue={value}
      name={key}
      onChange={(e) =>
        handleInputChange(rowData.index, e.target.name, e.target.value)
      }
      disabled={
        key === "margin"
          ? hideStates[rowData.index]
          : key === "interest_rate"
          ? !hideStates[rowData.index]
          : false
      }
    />
  );
};

export default HmfEdit;
